import { call, put, takeEvery } from "redux-saga/effects"

// Crypto Redux States
import { GET_USERDASHBOARD, GET_REPORTDASHBOARD } from "./actionTypes"

import {
  getuserDashboardSuccess,
  getuserDashboardFail,
  getReportDashboardSuccess,
  getReportDashboardFail,
} from "./actions"

import { getUserDashboard, getReportDashboard } from "helpers/backend_helper"


function* fetchUserDashboard() {
  try {
    const response = yield call(getUserDashboard)
    yield put(getuserDashboardSuccess(response))
    console.log("called->fetchUserDashboard->response, ", response)
    let groupType = response.groupType
    let groupName = response.groupName
    let branchName = response.branchName
    console.log("called->fetchUserDashboard->groupType, ", groupType)
    console.log("called->fetchUserDashboard->groupName, ", groupName)
    
    sessionStorage.setItem("groupType", JSON.stringify({
      groupType: groupType
    }));
    sessionStorage.setItem("groupName", JSON.stringify({
      groupName: groupName
    }));
    sessionStorage.setItem("branchName", JSON.stringify({
      branchName: branchName
    }));
  } catch (error) {
    yield put(getuserDashboardFail(error))
  }
}

function* fetchReportDashboard() {
  try {
    const response = yield call(getReportDashboard)
    yield put(getReportDashboardSuccess(response))
  } catch (error) {
    yield put(getReportDashboardFail(error))
  }
}

function* userDashboardSaga() {
  yield takeEvery(GET_USERDASHBOARD, fetchUserDashboard)
  yield takeEvery(GET_REPORTDASHBOARD, fetchReportDashboard)

}

export default userDashboardSaga
